module.exports = __webpack_public_path__ + "static/media/profile.580117f1.jpg";